import { render } from "./NotificationAddItemPane.vue?vue&type=template&id=ab82b0f4&scoped=true&ts=true"
import script from "./NotificationAddItemPane.vue?vue&type=script&lang=ts"
export * from "./NotificationAddItemPane.vue?vue&type=script&lang=ts"

import "./NotificationAddItemPane.vue?vue&type=style&index=0&id=ab82b0f4&scoped=true&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab82b0f4"]])

export default __exports__